import React, { useState, useEffect, useRef } from "react";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { useIntl, FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import LoaderSimple from "../general/loader";
import ReconciliationMovementCard from "./movementCard";
import moment from "moment";
import MovementsHeader from "./movementsHeader";
import { useReconciliation } from "../../customHooks/useReconciliation";

const periods = ["today", "lastWeek", "lastMonth"];
const periodsDate = {
  today: [moment().endOf("day"), moment().startOf("day")],
  lastWeek: [moment().subtract(1, "d"), moment().subtract(7, "d")],
  lastMonth: [moment().subtract(8, "d"), moment().startOf("month")],
};

const ReconciliationMovements = (props) => {
  const {
    onFiltersMovementsChange,
    onLinkedToClick,
    selectedMovements,
    setSelectedMovements,
    setSelectedMovementDetails,
    setStartDate,
    setEndDate,
    startDate,
    endDate,
    activeFilters,
    filterDateRange,
    setFilterDateRange,
  } = props;

  const movementsRef = useRef();
  const reconciliation = useSelector((state) => state.reconciliation);
  const movements = reconciliation?.movements?.list;

  const reconciliationHook = useReconciliation();

  const [movementsToShow, setMovementsToShow] = useState(movements);

  const [showAllMovements, setShowAllMovements] = useState(false);

  const noData = useIntl().formatMessage({
    id: "reconciliation.movements.nodata",
  });

  useEffect(() => {
    if (!movementsRef.current) return undefined;
    let ps = new Scrollbar(movementsRef.current, { wheelPropagation: true });
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [movementsRef?.current]);

  useEffect(() => {
    let docObj = document.getElementById("dbx-reconciliation-movement-card_" + selectedMovements[0]);
    if (docObj) {
      docObj.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [selectedMovements]);

  useEffect(() => {
    if (showAllMovements) {
      setStartDate(moment().subtract(2, "y").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("day").format("YYYY-MM-DD"));
    }
  }, [showAllMovements]);

  const renderMovementsTitles = (period) =>
    useIntl().formatMessage({
      id: "reconciliation.movements.titles." + period,
    });

  const groupMovements = (movements) => {
    let retList = {};
    movements.forEach((movement) => {
      if (reconciliationHook.filterIban !== "all" && reconciliationHook.filterIban !== movement.iban) {
        return;
      }
      let dateToCheck = new moment(movement?.transactionDate?.split("T")[0], "YYYY-MM-DD");
      periods.forEach((period) => {
        if (dateToCheck <= periodsDate[period][0] && dateToCheck >= periodsDate[period][1]) {
          if (!retList[period]) {
            retList[period] = [];
          }
          retList[period].push(movement);
        }
      });
    });
    return retList;
  };

  const allMovements = () => {
    const allMovementsCards = movementsToShow.map((movement, index) => {
      return (
        <ReconciliationMovementCard
          key={`movementsToShow_${index}`}
          className="dbx-reconciliation-movements-list-group-movement"
          movement={movement}
          onLinkedToClick={onLinkedToClick}
          selected={selectedMovements.indexOf(movement.id) > -1}
          selectedMovements={selectedMovements}
          onCardClick={(value) => {
            setSelectedMovements([value]);
            setSelectedMovementDetails(movement);
          }}
        />
      );
    });
    return allMovementsCards;
  };

  const renderMovements = () => {
    let sections = [];
    let items = {};
    let items2 = [];
    periods.map((period) => {
      return (items[period] = []);
    });
    if ((!movementsToShow || movementsToShow?.length < 1) && !reconciliation.movements.status.started) {
      return <div className="dbx-reconciliation-movements-list-nodata">{noData}</div>;
    }
    // Se il filtro della data è uguale a quello iniziale (mese corrente) vedo i raggruppamenti, altrimenti no
    if (!filterDateRange && !showAllMovements) {
      let groupedMovements = groupMovements(movementsToShow);
      if (Object.keys(groupedMovements).length === 0) {
        setShowAllMovements(true);
      }
      periods.map((period) => {
        if (groupedMovements[period]) {
          groupedMovements[period].map((movement) => {
            return items[period].push(
              <ReconciliationMovementCard
                className="dbx-reconciliation-movements-list-group-movement"
                movement={movement}
                onLinkedToClick={onLinkedToClick}
                selected={selectedMovements.indexOf(movement.id) > -1}
                selectedMovements={selectedMovements}
                onCardClick={(value) => {
                  setSelectedMovements([value]);
                  setSelectedMovementDetails(movement);
                }}
              />
            );
          });
          sections.push(
            <div className="dbx-reconciliation-movements-list-group">
              <div className="dbx-reconciliation-movements-list-group-title">{renderMovementsTitles(period)}</div>
              <div className="dbx-reconciliation-movements-list-group-movements">{items[period]}</div>
            </div>
          );
        }
        return null;
      });
    }
    if (filterDateRange && !showAllMovements) {
      movementsToShow.map((movement) => {
        return items2.push(
          <ReconciliationMovementCard
            className="dbx-reconciliation-movements-list-group-movement"
            movement={movement}
            onLinkedToClick={onLinkedToClick}
            selected={selectedMovements.indexOf(movement.id) > -1}
            selectedMovements={selectedMovements}
            onCardClick={(value) => {
              setSelectedMovements([value]);
              setSelectedMovementDetails(movement);
            }}
          />
        );
      });
      return items2;
    }

    return (
      <>
        {!showAllMovements ? (
          <>
            {sections}
            <div className="linkShowOther" style={{ marginTop: "20px" }} onClick={() => setShowAllMovements(true)}>
              <FormattedMessage id="deadlines.reconciliation.showOtherMovements" />
            </div>
          </>
        ) : (
          <>{allMovements()}</>
        )}
      </>
    );
  };

  return (
    <div className="dbx-reconciliation-movements-root">
      <MovementsHeader
        isAccountingPage={false}
        onFiltersMovementsChange={onFiltersMovementsChange}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        reconciliation={reconciliation}
        setFilterIban={reconciliationHook.setFilterIban}
        filterIban={reconciliationHook.filterIban}
        startDate={startDate}
        endDate={endDate}
        setMovementsToShow={setMovementsToShow}
        movements={movements}
        activeFilters={activeFilters}
        setFilterDateRange={setFilterDateRange}
      />
      <div className="dbx-reconciliation-movements-container" ref={movementsRef} id="movements-container">
        {reconciliation.movements.status.started ? (
          <div className="dbx-reconciliation-movements-loading">
            <LoaderSimple />
          </div>
        ) : (
          renderMovements()
        )}
        <div className="dbx-reconciliation-movements-fake-container"></div>
      </div>
    </div>
  );
};

export default ReconciliationMovements;
